import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  getByOrganizationId_1 as getCommunicationPropertiesByIdFn,
  GetByOrganizationId_1$Params,
} from '../../api/fn/communication-properties/get-by-organization-id-1';
import { catchError, map, Observable, of } from 'rxjs';
import { CommunicationProperties } from '../../api/models';
import {
  Create$Params,
  create as createCommunicationPropertiesFn,
} from '../../api/fn/communication-properties/create';
import {
  DeleteCommunicationProperties$Params,
  deleteCommunicationProperties as deleteCommunicationPropertiesFn,
} from '../../api/fn/communication-properties/delete-communication-properties';
import {
  Update$Params,
  update as updateCommunicationPropertiesFn,
} from '../../api/fn/communication-properties/update';
import {
  DeleteCommunicationPropertiesOperation$Params,
  deleteCommunicationPropertiesOperation as deleteCommunicationPropertiesOperationFn,
} from '../../api/fn/communication-properties/delete-communication-properties-operation';

@Injectable({ providedIn: 'root' })
export class CommunicationPropertiesService {
  constructor(private apiService: ApiService) {}

  getCommunicationPropertiesById(
    params: GetByOrganizationId_1$Params
  ): Observable<CommunicationProperties | undefined> {
    return this.apiService
      .invoke(getCommunicationPropertiesByIdFn, params)
      .pipe(map((response) => response.communicationProperties));
  }

  createCommunicationProperties(
    params: Create$Params
  ): Observable<CommunicationProperties> {
    return this.apiService.invoke(createCommunicationPropertiesFn, params);
  }

  deleteCommunicationProperties(
    params: DeleteCommunicationProperties$Params
  ): Observable<boolean> {
    return this.apiService.invoke(deleteCommunicationPropertiesFn, params).pipe(
      map(() => true),
      catchError((e) => {
        return of(false);
      })
    );
  }

  updateCommunicationPropertiesOperation(
    params: Update$Params
  ): Observable<boolean> {
    return this.apiService.invoke(updateCommunicationPropertiesFn, params).pipe(
      map(() => true),
      catchError((e) => {
        return of(false);
      })
    );
  }

  deleteCommunicationPropertiesOperation(
    params: DeleteCommunicationPropertiesOperation$Params
  ): Observable<boolean> {
    return this.apiService
      .invoke(deleteCommunicationPropertiesOperationFn, params)
      .pipe(
        map(() => true),
        catchError((e) => {
          return of(false);
        })
      );
  }
}
